<template>
    <p class="share-links" :class="{ 'layout2-share': theme === 'layout2' }">
        <a
            v-for="(shareLink, index) in newSocialNetworks"
            :key="shareLink.id + '-' + index"
            class="iconfont"
            :class="icons[shareLink.socialNetwork]?.icon"
            :href="shareLink.url"
            :aria-label="shareLink.socialNetwork"
            target="_blank"
            rel="noopener"
            @click.stop
            :style="{ color: theme === 'layout2' ? agentInfoColor : '#fff' }"
        ></a>
    </p>
</template>

<script>
export default {
    props: {
        socialNetworks: {
            type: Array,
            default: () => []
        },
        theme: {
            type: String,
            default: ''
        },
        agentInfoColor: {
            type: String,
            default: ''
        }
    },
    computed: {
        newSocialNetworks() {
            let arr = this.socialNetworks.filter(item => item.url);
            if (this.theme === 'layout1') {
                return arr.slice(0, 4);
            } else if (this.theme === 'layout2') {
                return arr.slice(0, 7);
            } else {
                return arr.slice(0, 3);
            }
        }
    },
    data: function() {
        return {
            icons: {
                facebook: {
                    icon: 'icon-agent-facebook',
                    back: {
                        backgroundColor: '#3b5998'
                    }
                },
                linkedin: {
                    icon: 'icon-agent-linkedin',
                    back: {
                        backgroundColor: '#4682b4'
                    }
                },
                twitter: {
                    icon: 'icon-newagent-twitter',
                    back: { backgroundColor: '#00bfff' }
                },
                zillow: {
                    icon: 'icon-agent-zillow',
                    back: { backgroundColor: '#1e90ff' }
                },
                yelp: {
                    icon: 'icon-agent-yelp',
                    back: { backgroundColor: '#c41200' }
                },
                instagram: {
                    icon: 'icon-instagram',
                    back: { backgroundColor: '#bc2a8d' }
                },
                youtube: {
                    icon: 'icon-youtube1',
                    back: { backgroundColor: '#dd332c' }
                },
                tiktok: {
                    icon: 'icon-tik-tok'
                },
                snapchat: {
                    icon: 'icon-snapchat',
                    back: { backgroundColor: '#fffc00' }
                },
                pinterest: {
                    icon: 'icon-agent-pinterest',
                    back: {
                        backgroundColor: '#cd2324'
                    }
                },
                angelist: {
                    icon: 'icon-agent-angelist',
                    back: { backgroundColor: '#000' }
                },
                'google+': {
                    icon: 'icon-google-sign',
                    back: { backgroundColor: '#d13e2f' }
                },
                whatsapp: {
                    icon: 'icon-agent-whatsapp',
                    back: { backgroundColor: '#00d41b' }
                },
                redfin: {
                    icon: 'icon-agent-redfin',
                    back: { backgroundColor: '#c11011' }
                }
            }
        };
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';

.md-team.template7-list {
    .share-links {
        width: 100%;
        padding: 0 10px;
        text-align: center;
        margin-top: 9%;

        .iconfont {
            cursor: pointer;
            border-radius: 2px;
            color: #fff;
            font-size: 16px;
            padding: 2px;
            text-align: center;
            background-size: 20px auto;
            background-repeat: no-repeat;
            background-position: 0 0;
            background-color: #000000;

            &:not(:nth-last-child(1)) {
                margin-right: 20px;
            }

            @include media-600 {
                width: 26px;
                height: 26px;
                margin-right: 10px;
                font-size: 12px;
            }

            &:last-child {
                margin-right: 0;
            }
        }

        .icon-agent-zillow,
        .icon-agent-yelp {
            font-size: 14px;
        }

        .icon-instagram-square {
            font-size: 18px;
        }
    }
}
</style>
